<template>
  <div class="search_engine">
    <!-- {{ invsyUser }} -->
    <!-- <button v-if="isStage" @click="testConirmationRoute()">Test Confirmation</button> -->
    <!-- This Loader displays on Api Requests -->
    <!-- <b-button @click="$router.push({ name: 'confirmation' })">
      test confirmation
    </b-button> -->
    <b-modal :active.sync="loader.isLoading" :can-cancel="[false, false, false]">
      <div class="loading-prompt">
        <clip-loader
          class="prompt-loader"
          :loading="loader.isLoading"
          color="#949494"
          size="100px"
        ></clip-loader>
        <h2 class="prompt-header">{{ loader.currentStep }}</h2>
      </div>
    </b-modal>
    <h1 class="search-engine-heading">Search for cars</h1>
    <div style=""></div>
    <div class="mobile-row">
      <b-radio
        v-model="radioRentalType"
        name="radioRentalType"
        native-value="domestic"
        >Domestic car rental</b-radio
      >
      <b-radio
        v-model="radioRentalType"
        name="radioRentalType"
        native-value="international"
        onclick="window.open('https://www.investectravel.com/international-car-rental/', '_self');"
        >International car rental</b-radio
      >
      <b-radio
        v-model="radioRentalType"
        name="radioRentalType"
        native-value="point-to-point"
        onclick="window.open('https://www.investectravel.com/point-to-point-transfer/', '_self');"
        >Point-to-point transfer</b-radio
      >
    </div>

    <div class="location-selection">
      <div class="pickup-location">
        <b-field class="expanded-field" expanded>
          <div class="autocomplete-wrapper">
            <b-autocomplete
              expanded
              :data="filteredLocations"
              placeholder="Pick-up location"
              field="pickupLocationQuery"
              :keep-first="true"
              :open-on-focus="true"
              autocomplete="false"
              @typing="getAsyncLocations"
              v-model="pickupLocationQuery"
              class="airport-picker"
              @select="
                option => {
                  pickupLocationQuery = option;
                }
              "
            >
              <template slot-scope="props">
                <div class="media">
                  <div class="media-left">
                    <b-icon
                      v-if="props.option.toLowerCase().includes('airport')"
                      icon="airplane"
                    ></b-icon>
                    <b-icon v-else icon="city"></b-icon>
                  </div>
                  <div class="media-content">{{ props.option }}</div>
                </div>
              </template>
            </b-autocomplete>
            <div
              class="clear-button"
              v-if="pickupLocationQuery"
              @click="pickupLocationQuery = ''"
            >
              <b-icon icon="close" size="is-small"></b-icon>
            </div>
            <span class="custom-label" v-if="pickupLocationQuery">
              Pick-up location
            </span>
          </div>
        </b-field>
      </div>
      <div class="dropoff-checkbox">
        <input
          type="checkbox"
          id="dropoff-checkbox"
          v-model="alternateDropoffLocation"
          @keydown.enter="alternateDropoffLocation = !alternateDropoffLocation"
        />
        Drop off car at a different location?
      </div>
      <transition name="slide-in">
        <div class="dropoff-location" v-if="alternateDropoffLocation">
          <b-field class="expanded-field" expanded>
            <div class="autocomplete-wrapper">
              <b-autocomplete
                expanded
                :data="filteredLocations"
                placeholder="City, district or airport"
                field="dropoffLocationQuery"
                autocomplete="false"
                class="airport-picker"
                @typing="getAsyncLocations"
                v-model="dropoffLocationQuery"
                @select="
                  option => {
                    dropoffLocationQuery = option;
                  }
                "
              >
                <template slot-scope="props">
                  <div class="media">
                    <div class="media-left">
                      <b-icon
                        v-if="props.option.toLowerCase().includes('airport')"
                        icon="airplane"
                      ></b-icon>
                      <b-icon v-else icon="city"></b-icon>
                    </div>
                    <div class="media-content">{{ props.option }}</div>
                  </div>
                </template>
              </b-autocomplete>
              <div
                class="clear-button"
                v-if="alternateDropoffLocation && dropoffLocationQuery"
                @click="dropoffLocationQuery = ''"
              >
                <b-icon icon="close" size="is-small"></b-icon>
              </div>
              <span class="custom-label" v-if="dropoffLocationQuery">
                Drop-off location
              </span>
            </div>
          </b-field>
        </div>
      </transition>
    </div>
    <transition name="slide-in">
      <div class="datepicker" v-if="locationSelected">
        <div for="datepicker" style="font-size: 16px">
          Please select your
          <b class="primary">pick-up</b> and
          <b class="secondary">drop-off</b>
          dates:
        </div>
        <span class="time-picker-container">
          <CustomDatepickerV2
            id="datepicker-pick-up"
            ref="pickupDatepicker"
            locale="en-GB"
            :input-props="{
              placeholder: 'Please select date'
            }"
            v-model="dateRange.start"
            @dateSelected="handleSelectionDate"
            :min-date="new Date()"
          >
            <img
              src="@/assets/images/icons/finance-calendar.png"
              alt="calendar icon"
            />
          </CustomDatepickerV2>

          <CustomDatepickerV2
            id="datepicker-drop-off"
            ref="dropoffDatepicker"
            locale="en-GB"
            :input-props="{
              placeholder: 'Please select date'
            }"
            v-model="dateRange.end"
            :key="refreshKey + 'end'"
            :min-date="dateRange.start ? dateRange.start : new Date()"
            :pickup-month="pickupMonth"
            :pickup-year="pickupYear"
            @keydown.tab="focusNext('dropoffDatepicker')"
          >
            <img
              src="@/assets/images/icons/finance-calendar.png"
              alt="calendar icon"
            />
          </CustomDatepickerV2>
        </span>
      </div>
    </transition>
    <transition name="slide-in">
      <div class="time-picker-container" v-if="locationSelected && dateSelected">
        <div class="time-picker-segment" id="pickupTimeInput">
          <custom-select
            ref="pickupTimeInput"
            @keydown.tab="focusNext('pickupTimeInput')"
            v-model="pickupTime"
            :options="timelist"
            placeholder="Pick-up time"
            type="time"
            :key="refreshKey + 'pickup'"
          />
          <label v-if="!validPickup" class="error-label" for="errors"
            >Please select a valid pick-up time</label
          >
        </div>
        <div class="time-picker-segment" id="dropoffTimeInput">
          <custom-select
            ref="dropoffTimeInput"
            v-model="dropoffTime"
            :options="timelist"
            placeholder="Drop-off time"
            type="time"
            :key="refreshKey + 'dropoff'"
            :class="{ 'is-error': dropoffTimeChangeRequest }"
          />
          <br />
          <label v-if="!validDropoff" class="error-label" for="errors"
            >Please select a valid drop-off time</label
          >
          <label
            v-if="dropoffTimeChangeRequest && validDropoff"
            class="error-label"
            for="errors"
            >Please select a later drop-off time for same day rental.</label
          >
        </div>
      </div>
    </transition>

    <!-- Flight Details Request Checkbox-->
    <transition name="slide-in">
      <div
        class="details-segment"
        v-if="locationSelected && dateSelected && timeSelected"
      >
        Are you arriving on a flight?
        <div style="display: flex; flex-direction: row">
          <div class="dropoff-checkbox">
            <input
              type="checkbox"
              id="yes-checkbox"
              v-model="isFlightDetailsYes"
              @change="onflightDetailsRequestYes"
            />
            <span style="padding-left: 8px">No</span>
          </div>
          <div class="dropoff-checkbox" style="margin-left: 16px">
            <input
              type="checkbox"
              id="yes-checkbox"
              v-model="isFlightDetailsNo"
              @change="onflightDetailsRequestNo"
            />
            <span style="padding-left: 8px">Yes</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- Flight Details Request -->
    <transition name="slide-in" >
      <div
        class="airline-details"
        v-if="
          locationSelected &&
            dateSelected &&
            timeSelected &&
            flightDetailsRequestSelected
        "
      >
        <b-field class="expanded-field" expanded>
          <div class="autocomplete-wrapper">
            <b-autocomplete
              expanded
              :data="filteredAirlineCodes"
              placeholder="Search airline"
              :field="airlineCodeQuery"
              :keep-first="true"
              :open-on-focus="true"
              autocomplete="false"
              @typing="filterAirlineCodes"
              v-model="airlineCodeQuery"
              class="airport-picker"
              @select="selectAirline"
            >
              <template slot-scope="props">
                <div class="media">
                  <div class="media-left">
                    <b-icon icon="airplane"></b-icon>
                  </div>
                  <div class="media-content">{{ props.option.name }} ({{ props.option.code }})</div>
                </div>
              </template>
            </b-autocomplete>
            <div
              class="clear-button"
              v-if="airlineCodeQuery"
              @click="clearAirlineCodeQuery"
            >
              <b-icon icon="close" size="is-small"></b-icon>
            </div>
            <span class="custom-label" v-if="airlineCodeQuery">
              Airline
            </span>
          </div>
        </b-field>
        <CustomDetailsInput
          v-model="flightNumber"
          placeholder="Add Flight number"
          @input="validateFlightNumber"
          type="number"
        />
      </div>
    </transition>

    <transition name="slide-in">
      <div
        class="details-container"
        v-if="
          locationSelected &&
            dateSelected &&
            timeSelected &&
            flightDetailsCompleted
        "
      >
        <div class="details-segment width-100" id="carTypeInput">
          <custom-select
            v-model="searchParameters.carType"
            :options="carTypes"
            placeholder="Car type"
            :key="refreshKey + 'carType'"
            :has-error="showCarTypeError"
            @input="showCarTypeError = false"
          />
          <label v-if="showCarTypeError" class="error-label">
            Please select a car type.
          </label>
        </div>

        <div class="details-segment width-100" id="countryInput">
          <custom-select
            v-model="searchParameters.country"
            :options="countrylist"
            placeholder="Country of residence"
            type="country"
            :key="refreshKey + 'country'"
            :has-error="showCountryError"
            @input="showCountryError = false"
          />
          <label v-if="showCountryError" class="error-label">
            Please select your country of residence.
          </label>
        </div>

        <div
          class="details-segment"
          id="licenseInput"
          :class="{ 'license-field-error': showLicenseError }"
        >
          Have you had your driver's licence for more than 2 years?
          <div style="display: flex; flex-direction: row">
            <div class="dropoff-checkbox">
              <input
                type="checkbox"
                id="yes-checkbox"
                v-model="searchParameters.isLicenseOld"
                @change="onLicenseOldChange"
              />
              <span style="padding-left: 8px">Yes</span>
            </div>
            <div class="dropoff-checkbox" style="margin-left: 16px">
              <input
                type="checkbox"
                id="yes-checkbox"
                v-model="searchParameters.isLicenseNew"
                @change="onLicenseNewChange"
              />
              <span style="padding-left: 8px">No</span>
            </div>
          </div>

          <label v-if="showLicenseError" class="error-label">
            Please specify if you've been in possession of a license for more
            than 2 years.
          </label>
        </div>
      </div>
    </transition>
    <b-message type="is-danger" class="error-label" v-if="searchError">{{ searchError }}</b-message>
    <transition name="slide-in">
      <div class="search-button-container">
        <b-button
          v-on:click="search()"
          type="is-primary"
          class="search-button"
          :class="searchIsReady ? 'button-ready' : ''"
          v-if="
            locationSelected &&
              dateSelected &&
              timeSelected &&
              flightDetailsCompleted
          "
          >Search cars</b-button
        >
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import debounce from "lodash/debounce";
import { allLocations, getLocationName } from "@/services/Location.service.js";
import { times } from "@/services/Time.service.js";
import { Cars } from "@/services/Car.service.js";
import { mapState } from "vuex";
import moment from "moment";
import VCalendar from "v-calendar";
import Loading from "vue-loading-overlay";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import countrycodes from "@/services/CountryCodes.service.js";
import CustomSelect from "@/components/CustomSelect.vue";
import CustomDatepickerV2 from "@/components/CustomDatepickerV2.vue";
import { error } from "jquery";
import Api from "@/services/Api.service.js";
import airlineCodes from '@/services/AirlineCodes.service.js';
import CustomDetailsSelect from "@/components/CustomDetailsSelect.vue";
import CustomDetailsInput from "@/components/CustomDetailsInput.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

Vue.use(VCalendar, {
  firstDayOfWeek: 3,
  datePickerTintColor: "#e60001"
});

export default {
  name: "SearchEngine",
  data: function() {
    return {
      focusSequence: {
        dropoffDatepicker: "pickupTimeInput",
        pickupTimeInput: "dropoffTimeInput"
      },
      radioRentalType: "domestic",
      labelPosition: null,
      filteredLocations: [],
      filteredTimes: [],
      carTypes: ["All", "Economy", "Luxury", "SUV", "4x4", "Minivan", "Light Trucks"],
      dateSelectionPrompt: `Please select your <b class="primary">pick-up</b> date:`,
      licenseOld: false,
      licenseNotOld: true,
      searchParameters: {
        pickupLocation: undefined,
        dropoffLocation: undefined,
        dropoffTime: undefined,
        pickupTime: undefined,
        carType: undefined,
        country: undefined,
        totalDays: undefined,
        isLicenseOld: false,
        isLicenseOldSet: true,
        isLicenseNew: false
      },
      dateRange: {
        start: undefined,
        end: undefined
      },
      loader: {
        isLoading: false,
        stepCount: 3000,
        backgroundColor: "linear-gradient(to right, lightgray, gray)",
        opacity: 0.5,
        spinnerSize: "22px",
        spinnerColor: "#485DC5",
        currentStep: "Connecting to our partners.",
      },
      pickupTime: "",
      validPickup: true,
      validDropoff: true,
      dropoffTimeChangeRequest: false,
      dropoffTime: "",
      pickupLocationQuery: this.isQuerySearch
        ? this.$route.query.pickupLocation
        : "",
      searchError: undefined,
      showCarTypeError: false,
      showCountryError: false,
      showLicenseError: false,
      dropoffLocationQuery: "",
      alternateDropoffLocation: false,
      locations: allLocations,
      times: times,
      cars: Cars,
      pickupDropoffMessage: "",
      refreshKey: 0,
      pickupMonth: null,
      pickupYear: null,
      //airline request
      isFlightDetailsYes: false,
      isFlightDetailsNo: false,
      flightDetailsRequestSelected: false,
      flightDetailsCompleted: false,
      flightNumber: null,
      //airline query
      airlineCodes: airlineCodes,
      airlineCodeQuery: null,
      selectedAirline: null
    };
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    }
  },
  methods: {
    validateFlightNumber() {
      if (this.flightNumber && this.selectedAirlineDisplay != null) {
        this.flightDetailsCompleted = true;
      } else if (!this.flightNumber || this.selectedAirlineDisplay != null) {
        this.flightDetailsCompleted = false;
      }
    },
    filterAirlineCodes(query) {
      this.airlineCodeQuery = query || ''; 
    },
    selectAirline(option) {
      this.selectedAirline = option;
      this.selectedAirlineDisplay = `${option.name} (${option.code})`;
      this.airlineCodeQuery = `${option.name} (${option.code})`;
    },
    clearAirlineCodeQuery() {
      this.airlineCodeQuery = '';
      this.selectedAirlineDisplay = null;
      this.selectedAirline = null;
    },
    modifyPickupTime() {
      this.dateRange.start.setHours(
        this.pickupTime.split(":")[0],
        this.pickupTime.split(":")[1]
      );
    },
    modifyDropoffTime() {
      this.dateRange.end.setHours(
        this.dropoffTime.split(":")[0],
        this.dropoffTime.split(":")[1]
      );
    },
    focusNext(currentRef) {
      const nextRef = this.focusSequence[currentRef];
      if (nextRef && this.$refs[nextRef]) {
        this.$refs[nextRef].focus();
      }
    },
    testConirmationRoute() {
      this.$router.push({ name: "confirmation" });
    },
    onLicenseOldChange() {
      this.searchParameters.isLicenseNew = !this.searchParameters.isLicenseOld;
      this.showLicenseError = false;
    },
    onLicenseNewChange() {
      this.searchParameters.isLicenseOld = !this.searchParameters.isLicenseNew;
      this.showLicenseError = false;
    },
    onflightDetailsRequestYes() {
      this.isFlightDetailsNo = !this.isFlightDetailsYes; //toggles check marks
      this.flightDetailsRequestSelected = this.isFlightDetailsNo; //toggles input boxes
      this.isFlightDetailsYes
        ? (this.flightDetailsCompleted = true)
        : (this.flightDetailsCompleted = false);
    },
    onflightDetailsRequestNo() {
      this.isFlightDetailsYes = !this.isFlightDetailsNo; //toggles check marks
      this.clearAirlineCodeQuery();
      this.flightNumber = null;
      this.flightDetailsRequestSelected = this.isFlightDetailsNo; //toggles input boxes
      this.isFlightDetailsYes
        ? (this.flightDetailsCompleted = true)
        : (this.flightDetailsCompleted = false);
    },
    getAsyncLocations: debounce(function(query) {
      if (query.length) {
        let lowerCaseQuery = query.toLowerCase();
        this.filteredLocations = this.locationNames.filter(location =>
          location.toLowerCase().includes(lowerCaseQuery)
        );
      }
    }, 300),
    getAsyncTimes: debounce(function(query) {
      if (query.length) {
        this.filteredTimes = this.times.filter(time => time.includes(query));
      }
    }, 300),
    isQuarentine() {
      return new Date() < new Date(2020, 3, 16);
    },
    mapList: function() {
      this.locations.map(a => {
        return { name: a.locationName };
      });
    },
    setPickupLocation: function(newVal) {
      this.searchParameters.pickupLocation = this.locations.find(location => {
        return location.locationName == newVal;
      });
      if (!this.alternateDropoffLocation) {
        this.searchParameters.dropoffLocation = this.locations.find(
          location => {
            return location.locationName == newVal;
          }
        );
      }
    },
    setDropoffLocation: function(newVal) {
      this.searchParameters.dropoffLocation = this.locations.find(location => {
        return location.locationName == newVal;
      });
    },
    validateRequiredSearchFields() {
      let valid = true;
      let firstErrorId = null;

      const flagError = (field, id) => {
        this[field] = true;
        if (valid) {
          firstErrorId = id;
        }
        valid = false;
      };

      this.showCarTypeError = false;
      this.showCountryError = false;
      this.showLicenseError = false;

      if (!this.searchParameters.carType) {
        flagError("showCarTypeError", "carTypeInput");
      }
      if (!this.searchParameters.country) {
        flagError("showCountryError", "countryInput");
      }
      if (
        !this.searchParameters.isLicenseOld &&
        !this.searchParameters.isLicenseNew
      ) {
        flagError("showLicenseError", "licenseInput");
      }

      if (firstErrorId) {
        this.scrollToError(firstErrorId);
      }

      return valid;
    },
    async search() {
      this.searchError = undefined;

      if (!this.validateRequiredSearchFields()) {
        return;
      }

      this.searchParameters.isLicenseOldSet = true;
      this.loader.isLoading = true;

      try {
        this.setTimes();
        if (!this.validPickup) {
          this.scrollToError("pickupTimeInput");
        }
        if (!this.validDropoff || this.dropoffTimeChangeRequest) {
          this.scrollToError("dropoffTimeInput");
        }
        if (this.validPickup && this.validDropoff) {
          this.loader.isLoading = true;
          this.searchParameters.totalDays = this.getTotalDays();
 
        const validationPayload = {
          pickupTime: this.searchParameters.pickupTime ? this.searchParameters.pickupTime.format("DD/MM/YYYY HH:mm") : ''
        };

        const validationResult = await Api.validateSearch(validationPayload);
    
        // If validation fails, show error and return
        if (!validationResult.data.status) {
            this.loader.isLoading = false;
            this.searchError = validationResult.data.message;
            return false;
        }
        
          let pickupState = false;
          let dropoffState = false;

          if (
            this.searchParameters.pickupLocation != undefined &&
            this.searchParameters.dropoffLocation != undefined
          ) {
            allLocations.forEach(location => {
              if (
                this.searchParameters.pickupLocation.locationName ==
                location.locationName
              ) {
                pickupState = true;
              }

              if (
                this.searchParameters.dropoffLocation.locationName ==
                location.locationName
              ) {
                dropoffState = true;
              }
            });
          } else if (this.searchParameters.dropoffLocation == undefined) {
            pickupState = true;
          }

          if (!pickupState) {
            this.loader.isLoading = false;
            this.searchError = "A valid pick-up location must be selected.";
            return false;
          }
          if (this.dropoffTimeChangeRequest) {
            this.loader.isLoading = false;
            this.searchError =
              "Please select a later drop-off time for same day rental.";
            return false;
          }
          if (!dropoffState) {
            this.loader.isLoading = false;
            this.searchError = "A valid dropoff location must be selected.";
            return false;
          }
          if (
            this.searchParameters.pickupLocation.locationName !==
            this.searchParameters.dropoffLocation.locationName
          ) {
            this.$store.commit("setOneway", true);
          } else {
            this.$store.commit("setOneway", false);
          }
          let query = {
            search: this.searchParameters,
            priorSearch: {
              pickupLocationQuery: this.pickupLocationQuery,
              dropoffLocationQuery: this.dropoffLocationQuery,
              pickupTime: this.pickupTime,
              dropoffTime: this.dropoffTime,
              dateRange: this.dateRange,
              carType: this.searchParameters.carType,
              country: this.searchParameters.country,
              isFlightDetailsYes: this.isFlightDetailsYes,
              isFlightDetailsNo: this.isFlightDetailsNo,
              isLicenseOld: this.searchParameters.isLicenseOld,
              isLicenseNew: this.searchParameters.isLicenseNew,
              flightDetailsRequestSelected: this.flightDetailsRequestSelected,
              flightDetailsCompleted: this.flightDetailsCompleted,
              selectedAirline: this.selectedAirline,
              airlineCodeQuery: this.airlineCodeQuery,
              flightNumber: this.flightNumber
            }
          };
          this.$store.commit("setSearchParameters", query);

          if (this.searchParameters.isLicenseOld == undefined) {
            this.searchParameters.isLicenseOldSet = false;
            this.loader.isLoading = false;
            return false;
          }

          this.$store.commit("setCars", Cars);
          this.$router.push("/results");
          this.loader.isLoading = false;
        }

        if (this.flightDetailsCompleted && this.selectedAirline !== null){
          this.$store.commit(
            "setFlightDetails",
            this.selectedAirline.code + this.flightNumber
          );
          // console.log("flightDetails:", this.selectedAirline.code + this.flightNumber);
        }
      } catch (error) {
        this.loader.isLoading = false;
        this.searchError = error.response.data.message || "An error occurred during the search.";
        return false;
      }
    },
    // Scroll to the location of the first encountered validation error
    scrollToError(id) {
      this.$nextTick(() => {
        document
          .getElementById(id)
          .scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },
    setTimes: function() {
      let re = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
      this.validPickup = re.test(this.pickupTime) ? true : false;
      this.validDropoff = re.test(this.dropoffTime) ? true : false;
      if (this.validPickup && this.validDropoff) {
        this.dateRange.start.setHours(
          this.pickupTime.split(":")[0],
          this.pickupTime.split(":")[1]
        );
        this.dateRange.end.setHours(
          this.dropoffTime.split(":")[0],
          this.dropoffTime.split(":")[1]
        );
        this.searchParameters.pickupTime = moment(this.dateRange.start);
        this.searchParameters.dropoffTime = moment(this.dateRange.end);
      }
    },
    getTotalDays() {
      let a = this.searchParameters.pickupTime;
      let b = this.searchParameters.dropoffTime;
      let days = b.diff(a, "days", true);
      if (a.hours() === b.hours() && a.minutes() === b.minutes()) {
        if (days < 1) {
          console.log("days", days);
          return 1;
        }
        return Math.round(days);
      }
      return Math.ceil(days);
    },
    // Datepicker helpers
    handleSelectionDate(month, year) {
      this.pickupMonth = month;
      this.pickupYear = year;
      this.refreshKey++;
    },
    // If dropoff < pickup time, set dropoff = pickup + 1 hour. If dropoff within 1 hour trigger error flag
    checkSameDayPickupDropoffTimes() {
      if (this.isSameDay) {
        if (this.isDropoffLessThanPickup) {
          this.dropoffTime = moment(this.pickupTime, "HH:mm")
            .add(1, "hour")
            .format("HH:mm");
          this.refreshKey++;
          this.modifyDropoffTime();
        } else if (this.isDropoffWithinOneHourFromPickup) {
          this.dropoffTimeChangeRequest = true;
          this.modifyDropoffTime();
        } else {
          this.dropoffTimeChangeRequest = false;
        }
      } else if (!this.isSameDay) {
        this.dropoffTimeChangeRequest = false;
      }
    }
  },
  mounted() {
    if (this.$route.query.pickupLocation) {
      this.pickupLocationQuery = getLocationName(
        this.$route.query.pickupLocation
      );

      if (this.$route.query.dropoffLocation) {
        this.alternateDropoffLocation = true;
        this.dropoffLocationQuery = getLocationName(
          this.$route.query.dropoffLocation
        );
      }

      let startDate = this.$route.query.pickupTime.split("T")[0].split("-");
      let endDate = this.$route.query.dropoffTime.split("T")[0].split("-");

      this.dateRange.start = new Date(
        startDate[2],
        startDate[1] - 1,
        startDate[0]
      );
      this.dateRange.end = new Date(endDate[2], endDate[1] - 1, endDate[0]);
      this.pickupTime = this.$route.query.pickupTime.split("T")[1];
      this.dropoffTime = this.$route.query.dropoffTime.split("T")[1];
      this.refreshKey++;
    } else if (this.priorSearch) {
      this.pickupLocationQuery = this.priorSearchParams.pickupLocationQuery;
      this.validPickup = true;

      if (this.priorSearchParams.dropoffLocationQuery) {
        this.alternateDropoffLocation = true;
        this.validDropoff = true;
        this.dropoffLocationQuery = this.priorSearchParams.dropoffLocationQuery;
      }

      this.dateRange = this.priorSearchParams.dateRange;
      this.pickupTime = this.priorSearchParams.pickupTime;
      this.dropoffTime = this.priorSearchParams.dropoffTime;
      this.searchParameters.carType = this.priorSearchParams.carType;
      this.searchParameters.country = this.priorSearchParams.country;
      
      // Restore flight details and license checkboxes
      this.isFlightDetailsYes = this.priorSearchParams.isFlightDetailsYes || false;
      this.isFlightDetailsNo = this.priorSearchParams.isFlightDetailsNo || false;
      this.flightDetailsRequestSelected = this.priorSearchParams.flightDetailsRequestSelected || false;
      this.flightDetailsCompleted = this.priorSearchParams.flightDetailsCompleted || false;
      this.selectedAirline = this.priorSearchParams.selectedAirline || null;
      this.airlineCodeQuery = this.priorSearchParams.airlineCodeQuery || '';
      this.flightNumber = this.priorSearchParams.flightNumber || null;
      this.searchParameters.isLicenseOld = this.priorSearchParams.isLicenseOld;
      this.searchParameters.isLicenseNew = this.priorSearchParams.isLicenseNew;
      
      this.refreshKey++;
    }
  },
  watch: {
    flightNumber() {
      this.validateFlightNumber();
    },
    airlineCodeQuery(newVal) {
      if (newVal === undefined) {
      this.airlineCodeQuery = this.selectedAirlineDisplay;
      this.validateFlightNumber();
      }
    },
    pickupLocationQuery: function(newVal) {
      this.setPickupLocation(newVal);
    },
    dropoffLocationQuery: function(newVal) {
      this.setDropoffLocation(newVal);
    },
    alternateDropoffLocation: function(newValue) {
      if (!newValue) {
        this.searchParameters.dropoffLocation = this.searchParameters.pickupLocation;
      }
    },
    pickupTime: function() {
      this.checkSameDayPickupDropoffTimes();
      this.modifyPickupTime();
    },
    dropoffTime: function() {
      this.checkSameDayPickupDropoffTimes();
    },
    "dateRange.end": function() {
      this.checkSameDayPickupDropoffTimes();
    },
    "dateRange.start": function(newVal) {
      // ddep watcher for date range is start date is greater than end date seet end date to start date
      if (newVal > this.dateRange.end) {
        this.dateRange.end = newVal;
      }
      //If dropoff < pickup time, set dropoff = pickup + 1 hour. If dropoff within 1 hour trigger error flag
      this.checkSameDayPickupDropoffTimes();
    }
  },
  computed: {
    ...mapState([
      "isQuerySearch",
      "querySearchParameters",
      "priorSearch",
      "invsyUser"
    ]),
    ...mapState({
      priorSearchParams: state => state.priorSearchParams
    }),
    filteredAirlineCodes() {
      const query = this.airlineCodeQuery ? this.airlineCodeQuery.toLowerCase() : '';
      return this.airlineCodes.filter(airline => {
        const code = airline.code ? airline.code.toLowerCase() : '';
        const name = airline.name ? airline.name.toLowerCase() : '';
        return code.includes(query) || name.includes(query);
      });
    },
    isSameDay() {
      return this.dateRange.start && this.dateRange.end
        ? moment(this.dateRange.start).isSame(this.dateRange.end, "day")
        : false;
    },
    isDropoffLessThanPickup() {
      // this.pickupTime and this.dropoffTime in format 07:00 , 18:00 EventCounts, determine if dropoff is less than pickup
      return this.pickupTime && this.dropoffTime
        ? this.dropoffTime < this.pickupTime
        : false;
    },
    isDropoffWithinOneHourFromPickup() {
      return this.pickupTime && this.dropoffTime
        ? moment(this.dropoffTime, "HH:mm").diff(
            moment(this.pickupTime, "HH:mm"),
            "hours"
          ) < 1
        : false;
    },
    searchIsReady() {
      if (
        this.pickupLocationQuery &&
        (this.alternateDropoffLocation ? this.dropoffLocationQuery : true) &&
        this.dateRange.start &&
        this.dateRange.end &&
        this.pickupTime &&
        this.validPickup &&
        this.dropoffTime &&
        this.flightDetailsCompleted &&
        !this.dropoffTimeChangeRequest &&
        this.searchParameters.carType &&
        this.searchParameters.country &&
        (this.searchParameters.isLicenseOld ||
          this.searchParameters.isLicenseNew)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isStage() {
      return (
        process.env.VUE_APP_BASE_API_URL ==
        "https://stage-backend.investectravel.com/"
      );
    },
    inverseLicenseOld() {
      if (this.searchParameters.isLicenseOld == undefined) {
        return true;
      } else {
        return !this.searchParameters.isLicenseOld;
      }
    },
    dateSelected() {
      if (this.dateRange.start && this.dateRange.end) {
        return true;
      } else {
        return false;
      }
    },
    timeSelected() {
      if (this.dateRange.start && this.dateRange.end && this.pickupTime && this.dropoffTime) {
        return true;
      } else {
        return false;
      }
    },
    startDateDisplay() {
      if (this.dateRange.start) {
        return moment(this.dateRange.start).format("DD/MM/YYYY");
      } else {
        return "Pick-up";
      }
    },
    endDateDisplay() {
      if (this.dateRange.end) {
        return moment(this.dateRange.end).format("DD/MM/YYYY");
      } else {
        return "Drop-off";
      }
    },
    locationSelected() {
      this.refreshKey;
      if (this.$route.query.pickupLocation || this.priorSearch) {
        return true;
      }
      if (
        (!this.alternateDropoffLocation &&
          this.searchParameters.pickupLocation) ||
        (this.alternateDropoffLocation &&
          this.searchParameters.pickupLocation !==
            this.searchParameters.dropoffLocation)
      ) {
        return true;
      } else {
        return false;
      }
    },
    locationNames() {
      return this.locations.map(a => {
        return a.locationName;
      });
    },
    countrylist() {
      return countrycodes;
    },
    timelist() {
      return times;
    }
  },
  components: {
    Loading,
    ClipLoader,
    GridLoader,
    CustomSelect,
    CustomDatepickerV2,
    CustomDetailsSelect,
    CustomDetailsInput
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.b-radio {
  margin-right: 1rem;
}

.mobile-row {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.autocomplete-wrapper {
  position: relative;
}

// Airport picker input
.airport-picker ::v-deep div .input {
  height: 64px !important;
  border: none !important;
  box-shadow: none !important;
  background-color: hsl(60, 10%, 96%) !important;
  // color: rgba(135, 139, 149, 1) !important;
  color: rgba(48, 56, 74, 1);
  font-size: 16px !important;
  padding-right: 16px !important;
  padding-left: 16px !important;

  max-width: 100%; // Ensures the input doesn't grow beyond its container
  overflow: hidden; // Hide any content that gets too big for the input
  text-overflow: ellipsis; // Show an ellipsis when the text is too long
  white-space: nowrap;
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: grey;
  cursor: pointer;
}

.custom-label {
  position: absolute;
  top: 50%;
  left: 16px;
  top: 6px;
  font-size: 12px;
  color: #5b626f;
}

.input-with-icon {
  position: relative;
}

.datepicker-input {
  padding-right: 40px; /* adjust as needed */
}

.calendar-icon {
  position: absolute;
  right: 10px; /* adjust as needed */
  top: 50%;
  transform: translateY(-50%);
  transform: translateX(-50%);
}

.search-engine-heading {
  color: #30384a;
  //styleName: display/display4;
  font-family: Libre Caslon Text;
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
  letter-spacing: -0.01em;
  text-align: left;
  max-width: 412px;
}

.expanded-field {
  width: 100%;
}

.primary {
  color: $primary-color;
}

.search-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 12px;
  gap: 4px;

  width: 117px;
  height: 40px;

  background: #d1d2d6 !important;
  color: #878b95 !important;
  border-radius: 104px;
}

.button-ready {
  background: $primary-color !important;
  color: white !important;
}

.search-button:hover {
  color: white !important;
}

.search-button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.slide-in {
  animation: slide-in-top 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.slide-in-enter-active {
  animation: slide-in-top 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.error-label {
  font-size: 0.8em;
  color: red;
  font-style: italic;
}

.is-error {
  box-shadow: 0px 0px 0px 1px red !important;
}

.license-field-error {
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0px 0px 0px 1px red;
}

.modal-background {
  background: #f0efed !important;
}

.loading-prompt {
  background: rgba(245, 245, 245, 0.95);
  color: #555555;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 1em;
  overflow: hidden !important;
  height: 100%;
  z-index: 99999 !important;
}

.prompt-header {
  font-size: 1em;
  text-align: center;
  color: #555555;
  margin-top: 1rem;
  padding: 1rem;
  font-family: "Helvetica Neue" !important;
  font-weight: bold;
}

.prompt-loader {
  margin-top: 3rem;
}

.savings-prompt {
  background: $gradient-color;
  color: $light;
  padding: 1em;
  width: 300px;
  margin: auto;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .heading,
  .content {
    color: $light;
    text-align: center;
  }
  .heading {
    font-size: 1.5em;
    font-weight: bold;
  }
}

.media-content {
  display: flex;
  flex-wrap: wrap;
  font-size: 10px !important;
}

@media (max-width: 768px) {
  .autocomplete .dropdown-item {
    white-space: normal !important;
  }
  .airport-picker ::v-deep div .input {
    padding-right: 24px !important;
  }
  .airline-details {
    flex-wrap: wrap;
  }
}

.custom-date-picker {
  background-color: #f6f6f4 !important;
  height: 64px !important;
  border-radius: 8px !important;
  border: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  font-size: 16px !important;
  width: 100% !important;
  display: flex;
  align-items: center;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  justify-content: space-between;
}

.search_engine {
  background: $light;
  margin: 0.75rem;
  padding: 20px;
  max-width: 536px;
  background: #ffffff;
  box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05), 0px 2px 8px -2px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  gap: 24px;
  flex-direction: column;
}

.location-selection {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
}

.pickup-location {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.airline-details {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}

.dropoff-checkbox {
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
}

#dropoff-checkbox {
  margin-right: 0.75em;
}

.dropoff-location {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.date-container {
  display: flex;
  width: 100%;
  align-items: center;
}

.date-icon {
  margin-right: 0.75em;
}

.datepicker {
  display: flex;
  gap: 24px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
  font-size: 16px !important;
  input {
    font-size: 16px !important;
  }
}

.time-picker-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
}

// Replaces inline styling of second date and time pickers on desktop
.time-picker-container .custom-date-picker:nth-of-type(2),
.time-picker-container .time-picker-segment:nth-of-type(2) {
}

.time-picker-segment {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-radius: 8px;
  justify-content: space-between;
}

.time-picker-segment + .time-picker-segment {
  margin-left: $standard-padding;
}

.details-container {
  gap: 24px;
  display: flex;
  flex-direction: column;

  .nested-details {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
}

.details-segment {
  display: flex;
  gap: 24px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.width-100 {
  width: 100%;
}

.age-check {
  margin: $standard-padding 0;
  text-align: left;
  width: 100%;
}

.age-input {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  margin: $standard-padding 0;
  width: 100%;
  overflow: hidden;
}

#age-input {
  width: 4rem;
  padding: 0.3em 0.5em;
  background: #f5f5f5;
  border: solid 1px #ddd;
  overflow: hidden;
  margin-left: $standard-padding * 2;
}

.autocomplete-input {
  width: 100%;
}

h1 {
  font-size: 20px;
}

input {
  padding: $standard-padding;
}

button {
  animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  margin: $standard-padding 0;
  padding: 1em 2em;
  width: 50%;
  background: $secondary-color;
  color: white;
  border: 1px solid black;
  border-radius: 8px;
}

@media (min-width: 781px) {
  .details-container {
    display: flex;
    flex-direction: column;

    .nested-details {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
    }
  }

  .details-segment {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .search_engine {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 40px;
  }

  .margin-top-0 {
    margin-top: 0 !important;
  }

  .limit-select {
    max-height: 250px !important;
  }

  #loading {
    width: 400px;
  }

  .savings-prompt {
    width: 400px;
  }
}
// Mobile styles
@media (max-width: 780px) {
  body .search_engine {
    padding: 62px 24px 62px 24px !important;
    gap: 24px;
  }
  .search-engine-heading {
    font-size: 32px !important;
    line-height: 38px !important;
  }
  label.b-radio.radio,
  label.b-radio.radio span.control-label,
  div.datepicker label {
    font-size: 16px;
    line-height: 24px;
  }
  .time-picker-container {
    flex-direction: column !important;
    gap: 24px;
    align-items: stretch;
  }
  .time-picker-container .custom-date-picker:nth-of-type(2),
  .time-picker-container .time-picker-segment:nth-of-type(2) {
    margin-left: 0 !important;
  }
  div.dropoff-checkbox {
    font-weight: 500;
  }
  .search-button-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .search-button-container button.search-button {
    width: 100%;
  }
  label.b-radio.radio {
  }
  // Removes margin issues on second radio
  label.b-radio.radio:nth-of-type(2) {
    margin-left: 0 !important;
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/settings.scss";

.label {
  font-weight: 400 !important;
}

.progress {
  overflow: visible !important;
}

.primary {
  color: $primary-color;
}

.secondary {
  color: $secondary-color;
}

// ISSUE: Everything below this point affects styles across site

.control-label {
  // height: 20px;
  left: 30px;
  top: 1px;
  //styleName: body/body;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-align: left;
}

/* Set the default color for the checkbox */
input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  border: 2px solid rgba(135, 139, 149, 1);
  border-radius: 4px;
  position: relative;
  width: 14px;
  height: 14px;
  transform: scale(0.8);
}

input[type="checkbox"]:checked {
  border-color: #30384a;
  background-color: #30384a;
}

input[type="checkbox"]::after {
  content: "";
  position: absolute;
  display: none;
}

input[type="checkbox"]:checked::after {
  content: "\2714";
  display: block;
  color: white;
  top: 0;
  left: 4px;
}

select {
  border-radius: 2px !important;
  background: white !important;
}

.b-radio.radio input[type="radio"]:checked + .check {
  border-color: #30384a !important;
}

.b-radio.radio input[type="radio"] + .check {
  height: 1em;
  width: 1em;
}

input[type="input"] {
  background-color: #f6f6f4 !important;
  height: 64px !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 16px !important;
}

select {
  background-color: #f6f6f4 !important;
  height: 64px !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: none !important;
}

.select {
  background-color: #f6f6f4 !important;
  height: 64px !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: none !important;
}

input[type="input"]:focus {
  box-shadow: none !important;
}

input[type="text"]:not(:placeholder-shown) {
  padding-top: 20px !important;
}

@media (max-width: 768px) {
  .autocomplete .dropdown-item {
    white-space: normal !important;
  }
  .media {
    align-items: center !important;
  }
}
</style>
